import * as React from "react";

import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Link,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

import { FooterLogo } from "../../atoms/Logo/FooterLogo";
import { PhoneIcon } from "@chakra-ui/icons";
import { ReactNode } from "react";

const ListHeader = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontWeight={"500"} fontSize={"lg"} mb={2}>
      {children}
    </Text>
  );
};

const CustomPhone = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    {/* SVG contents here */}
    <g clipPath="url(#clip0_532_899)">
      <path
        d="M9.70077 11.2856C9.54326 11.3801 9.48457 11.5796 9.56581 11.7443C10.3561 13.3469 11.6531 14.6439 13.2557 15.4342C13.4204 15.5154 13.6199 15.4567 13.7144 15.2992L14.6186 13.7923L17.6471 15.0037V17.5882C17.6471 17.8691 17.5355 18.1384 17.3369 18.3369C17.1407 18.5331 16.8755 18.6444 16.5983 18.647C13.9351 18.4824 11.4237 17.3502 9.53674 15.4633C7.6498 13.5763 6.51761 11.0649 6.35299 8.40173C6.35561 8.12454 6.46686 7.85927 6.66306 7.66306C6.86163 7.4645 7.13095 7.35294 7.41176 7.35294H9.99634L11.2077 10.3814L9.70077 11.2856Z"
        stroke="white"
        strokeOpacity="0.8"
        strokeWidth="0.705882"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_532_899">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CustomMail = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M18.75 8.25C18.75 7.42157 18.0784 6.75 17.25 6.75H6.75C5.92157 6.75 5.25 7.42157 5.25 8.25M18.75 8.25V15.75C18.75 16.5784 18.0784 17.25 17.25 17.25H6.75C5.92157 17.25 5.25 16.5784 5.25 15.75V8.25M18.75 8.25L12 12.75L5.25 8.25"
      stroke="white"
      strokeOpacity="0.8"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Fb = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0ZM19.79 11.0567H17.385C17.1 11.0567 16.7833 11.4317 16.7833 11.93V13.6667H19.7917L19.3367 16.1433H16.7833V23.5783H13.945V16.1433H11.37V13.6667H13.945V12.21C13.945 10.12 15.395 8.42167 17.385 8.42167H19.79V11.0567Z"
      fill="white"
      fill-opacity="0.8"
    />
  </svg>
);
const Ig = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M21 16C21 17.3261 20.4732 18.5979 19.5355 19.5355C18.5979 20.4732 17.3261 21 16 21C14.6739 21 13.4021 20.4732 12.4645 19.5355C11.5268 18.5979 11 17.3261 11 16C11 15.715 11.03 15.4367 11.0817 15.1667H9.33333V21.8283C9.33333 22.2917 9.70833 22.6667 10.1717 22.6667H21.83C22.0521 22.6662 22.2649 22.5777 22.4217 22.4205C22.5786 22.2634 22.6667 22.0504 22.6667 21.8283V15.1667H20.9183C20.97 15.4367 21 15.715 21 16ZM16 19.3333C16.4378 19.3332 16.8714 19.2469 17.2759 19.0792C17.6803 18.9116 18.0478 18.6659 18.3574 18.3562C18.6669 18.0465 18.9124 17.6789 19.0799 17.2743C19.2473 16.8698 19.3334 16.4362 19.3333 15.9983C19.3332 15.5605 19.2469 15.1269 19.0792 14.7225C18.9116 14.318 18.6659 13.9505 18.3562 13.641C18.0465 13.3314 17.6789 13.0859 17.2743 12.9185C16.8698 12.751 16.4362 12.6649 15.9983 12.665C15.1141 12.6652 14.2661 13.0167 13.641 13.6421C13.0158 14.2676 12.6648 15.1157 12.665 16C12.6652 16.8843 13.0167 17.7322 13.6421 18.3574C14.2676 18.9825 15.1157 19.3336 16 19.3333ZM20 12.5H21.9983C22.1311 12.5 22.2584 12.4474 22.3525 12.3537C22.4465 12.2599 22.4996 12.1328 22.5 12V10.0017C22.5 9.86862 22.4471 9.74102 22.3531 9.64693C22.259 9.55285 22.1314 9.5 21.9983 9.5H20C19.8669 9.5 19.7393 9.55285 19.6453 9.64693C19.5512 9.74102 19.4983 9.86862 19.4983 10.0017V12C19.5 12.275 19.725 12.5 20 12.5ZM16 0C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16C0 20.2435 1.68571 24.3131 4.68629 27.3137C7.68687 30.3143 11.7565 32 16 32C18.1012 32 20.1817 31.5861 22.1229 30.7821C24.0641 29.978 25.828 28.7994 27.3137 27.3137C28.7994 25.828 29.978 24.0641 30.7821 22.1229C31.5861 20.1817 32 18.1012 32 16C32 13.8989 31.5861 11.8183 30.7821 9.87706C29.978 7.93586 28.7994 6.17203 27.3137 4.68629C25.828 3.20055 24.0641 2.022 22.1229 1.21793C20.1817 0.413852 18.1012 0 16 0ZM24.3333 22.4817C24.3333 23.5 23.5 24.3333 22.4817 24.3333H9.51833C8.5 24.3333 7.66667 23.5 7.66667 22.4817V9.51833C7.66667 8.5 8.5 7.66667 9.51833 7.66667H22.4817C23.5 7.66667 24.3333 8.5 24.3333 9.51833V22.4817Z"
      fill="white"
      fill-opacity="0.8"
    />
  </svg>
);
const Tw = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16 0C7.16333 0 0 7.16333 0 16C0 24.8367 7.16333 32 16 32C24.8367 32 32 24.8367 32 16C32 7.16333 24.8367 0 16 0ZM22.5083 13.1067C22.515 13.2433 22.5167 13.38 22.5167 13.5133C22.5167 17.68 19.3483 22.4817 13.5517 22.4817C11.8388 22.4845 10.1616 21.9926 8.72167 21.065C8.96667 21.095 9.21833 21.1067 9.47333 21.1067C10.95 21.1067 12.3083 20.605 13.3867 19.7583C12.7295 19.7454 12.0928 19.5278 11.5652 19.1359C11.0376 18.7439 10.6454 18.1971 10.4433 17.5717C10.9153 17.6614 11.4014 17.6426 11.865 17.5167C11.1517 17.3724 10.5103 16.986 10.0495 16.4228C9.5887 15.8596 9.33684 15.1544 9.33667 14.4267V14.3883C9.76167 14.6233 10.2483 14.7667 10.765 14.7833C10.0963 14.3382 9.62298 13.6545 9.44174 12.8719C9.26051 12.0893 9.38509 11.2671 9.79 10.5733C10.5816 11.5467 11.5688 12.3429 12.6876 12.9105C13.8065 13.4781 15.032 13.8044 16.285 13.8683C16.1257 13.1922 16.1943 12.4823 16.48 11.8492C16.7658 11.216 17.2527 10.695 17.8651 10.3671C18.4775 10.0392 19.1811 9.92287 19.8665 10.0361C20.5519 10.1494 21.1806 10.4859 21.655 10.9933C22.3603 10.8538 23.0366 10.5951 23.655 10.2283C23.4199 10.9586 22.9278 11.5786 22.27 11.9733C22.8947 11.8981 23.5048 11.7301 24.08 11.475C23.6575 12.1082 23.1252 12.6607 22.5083 13.1067Z"
      fill="white"
      fill-opacity="0.8"
    />
  </svg>
);

const Li = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM12.2356 12.2759C12.4858 12.026 12.6265 11.6869 12.6266 11.3333C12.6268 10.9796 12.4865 10.6404 12.2366 10.3903C11.9867 10.1401 11.6476 9.99944 11.294 9.99927C10.9403 9.99909 10.6011 10.1394 10.351 10.3893C10.1008 10.6392 9.96014 10.9783 9.95996 11.3319C9.95978 11.6856 10.1001 12.0248 10.35 12.2749C10.5999 12.5251 10.939 12.6658 11.2926 12.6659C11.6462 12.6661 11.9855 12.5258 12.2356 12.2759ZM9.99996 13.6533H12.6666V21.9999H9.99996V13.6533ZM14.2266 13.6533H16.88L16.8533 14.7733C17.96 12.7533 22.6666 12.5999 22.6666 16.7133V21.9999H20.0333V17.6199C20.0333 14.9533 16.8533 15.1799 16.8533 17.6199V21.9999H14.2266V13.6533Z"
      fill="white"
      fill-opacity="0.8"
    />
    <defs>
      <clipPath id="clip0_1068_2293">
        <rect width="32" height="32" rx="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const today = new Date();

export const Footer = () => {
  return (
    <Box bg={"#09170D"} color={"rgba(255, 255, 255, 0.60)"} py="80px">
      <Container as={Stack} maxW={"container.xl"}>
        <Flex
          flexFlow={{ base: "column", lg: "wrap", xl: "row" }}
          justifyContent="space-between"
          alignItems={{ base: "flex-start", md: "flex-start" }}
          gap={16}
        >
          <Stack spacing={6}>
            <Box>
              <FooterLogo w="18.25rem" h="2.5rem" />
            </Box>
            <Text fontSize={"sm"}>
              © {today.getFullYear()}{" "}
              <Text as="span" textDecoration={"underline"}>
                <Link href="https://globaltiesalabama.org/" target="_blank">
                  Global Ties Alabama
                </Link>
              </Text>
              . <br />
              All Rights Reserved.
            </Text>
          </Stack>
          <Stack align={"flex-start"}>
            <Text fontSize={"md"} fontWeight={"700"}>
              HUNTSVILLE OFFICE
            </Text>
            <Text fontSize={"sm"}>
              Oakwood Industries <br /> 4920 University Sq, Suite D <br />{" "}
              Huntsville, Alabama 35816 <br />
              10:00AM - 4:00PM, Mon - Thu
            </Text>
            <HStack fontSize={"sm"}>
              <CustomPhone
                stroke="white"
                strokeOpacity="0.8"
                strokeWidth="0.705882"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <Link href={"tel:2565323560"}> 256-532-3560</Link>
            </HStack>
            <HStack fontSize={"sm"}>
              <CustomMail
                stroke="white"
                strokeOpacity="0.8"
                strokeWidth="0.705882"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <Link href={"mailto:gtahsv@madisoncountyal.gov"}>
                {" "}
                gtahsv@madisoncountyal.gov
              </Link>
            </HStack>
          </Stack>
          <Stack align={"flex-start"} w="274px">
            <Text fontSize={"md"} fontWeight={"700"}>
              MONTGOMERY OFFICE
            </Text>
            <Text fontSize={"sm"}>
              Troy University - Call for Appointments Whitley Hall Rm. 312, 231
              Montgomery St., Mongomery, AL 36104 <br /> *By appointment only
            </Text>
            <HStack fontSize={"sm"}>
              <CustomPhone
                stroke="white"
                strokeOpacity="0.8"
                strokeWidth="0.705882"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <Link href={"tel:2565323560"}> 256-532-3560</Link>
            </HStack>
            <HStack fontSize={"sm"}>
              <CustomMail
                stroke="white"
                strokeOpacity="0.8"
                strokeWidth="0.705882"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <Link href={"mailto:gta3@madisoncountyal.gov"}>
                {" "}
                gta3@madisoncountyal.gov
              </Link>
            </HStack>
          </Stack>
          <VStack alignItems={"flex-start"}>
            <Stack
              alignItems={"flex-start"}
              flexFlow={{ base: "column", md: "row" }}
              gap={4}
            >
              <Link _hover={{ textDecoration: "none" }} href="/get-involved">
                <Button
                  as={"a"}
                  aria-label="get-involved"
                  fontSize={"sm"}
                  fontWeight={600}
                  color={"white"}
                  variant={"link"}
                  border="1px solid #FFF"
                  borderRadius="0"
                  h="40px"
                  w={{ base: "343px", md: "auto" }}
                  px={6}
                  textTransform="uppercase"
                  _hover={{ color: "#000", bg: "#fff", textDecoration: "none" }}
                >
                  Get Involved
                </Button>
              </Link>
              <Link
                _hover={{ textDecoration: "none" }}
                href="https://donate.globaltiesalabama.org/donate/"
              >
                <Button
                  as={"a"}
                  aria-label="donate"
                  display={"inline-flex"}
                  fontSize={"sm"}
                  fontWeight={600}
                  color={"#D9A542"}
                  bg={"transparent"}
                  border={"1px solid #D9A542"}
                  borderRadius="0"
                  h="40px"
                  w={{ base: "343px", md: "auto" }}
                  px={6}
                  textTransform="uppercase"
                >
                  Donate
                </Button>
              </Link>
            </Stack>
            <HStack
              alignItems="center"
              justifyContent={"flex-start"}
              gap={5}
              mt={8}
              mx={{ base: "auto", md: "0" }}
            >
              <Link
                target="_blank"
                href="https://www.facebook.com/GlobalTiesAlabama"
              >
                <Fb />
              </Link>
              <Link target="_blank" href="https://twitter.com/globaltiesal">
                <Tw />
              </Link>
              <Link
                target="_blank"
                href="https://www.instagram.com/globaltiesal/"
              >
                <Ig />
              </Link>
              <Link
                target="_blank"
                href="https://www.linkedin.com/company/global-ties-alabama/"
              >
                <Li />
              </Link>
            </HStack>
          </VStack>
        </Flex>
      </Container>
    </Box>
  );
};
